import { DropdownMenu } from '@octopus-do/octopus-storybook'
import type React from 'react'

interface Option {
  value: string
  label: string
}

interface Props {
  options: Option[]
  active: string
}

export const OptionsContent: React.FC<Props> = ({ options, active }) => (
  <>
    {options.map((option) => (
      <DropdownMenu.Button
        key={option.value}
        id={option.value}
        title={option.label}
        active={active === option.value}
      />
    ))}
  </>
)
